import { render, staticRenderFns } from "./selectListButton.vue?vue&type=template&id=8b71b20e&"
import script from "./selectListButton.vue?vue&type=script&lang=js&"
export * from "./selectListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports